const topbar = {
    docs: 'Docs',
    help: 'Aide',
};
export default Object.freeze(topbar);
